import React, { useState } from "react";
import Sales from "../regular/Sales";
import Purchases from "../../../ass_components/account/business/Purchases";
import Activities from "../../../ass_components/account/business/Activities";
import Overview from "../../../ass_components/account/business/Overview";
import TopHeader from "../../../ass_components/TopHeader";
import PersonalHero from "../../../ass_components/account/business/PersonalHero";
import TabsNav from "../../../ass_components/account/business/TabsNav";
import Earnings from "../../../ass_components/account/business/Earnings";
import ActionFAB from "../../../ass_components/account/business/ActionFAB";
import HeaderAgro from "../../../ass_components/HeaderAgro";
import Notification from "../../../ass_components/account/business/notifications/Notifications";


const PersonalHub = () => {
    // L'onglet peut être imposé par l'URL (ex. retour de paiement : ?tab=notifications).
    const [activeTab, setActiveTab] = useState(
        () => new URLSearchParams(window.location.search).get("tab") || "notifications"
    );

    const renderContent = () => {
        switch (activeTab) {
            case "sales": return <Sales />;
            case "purchases": return <Purchases />;
            case "activities": return <Activities />;
            case "earnings": return <Earnings />;
            case "notifications": return <Notification />;
            default: return <Overview />;
        }
    };

    return (
        <>
            <TopHeader />
            <HeaderAgro />

            <div style={{ padding: "20px", background: "#F5F7FA", minHeight: "100vh" }}>
                <PersonalHero />

                <TabsNav activeTab={activeTab} setActiveTab={setActiveTab} />

                <div style={{ marginTop: 20 }}>
                    {renderContent()}
                </div>
            </div>

            <ActionFAB />
        </>
    );
};

export default PersonalHub;